import { stringStartsWith } from '@dazn/peng-html5-tools-utils';
var getPort = function (url) {
    var match = url.match(/:(\d+)/);
    if (match) {
        return parseInt(match[1], 10);
    }
    if (stringStartsWith(url, 'https:'))
        return 443;
    if (stringStartsWith(url, 'http:'))
        return 80;
    return undefined;
};
export { getPort };
//# sourceMappingURL=getPort.js.map